import { audioManager } from "../../utils/audioManager";

type VoicePreviewListener = (playingKey: string | null) => void;

let currentAudio: HTMLAudioElement | null = null;
let currentKey: string | null = null;
const listeners = new Set<VoicePreviewListener>();

function notify() {
    listeners.forEach((listener) => listener(currentKey));
}

function disposePreviewAudio(el: HTMLAudioElement | null) {
    if (!el) return;
    el.onended = null;
    el.onerror = null;
    try {
        el.pause();
        el.currentTime = 0;
        el.removeAttribute("src");
        el.load();
    } catch {
        // ignore
    }
}

export function getPlayingVoicePreviewKey(): string | null {
    return currentKey;
}

export function stopVoicePreview() {
    disposePreviewAudio(currentAudio);
    currentAudio = null;
    currentKey = null;
    notify();
}

export function playVoicePreview(key: string, url: string) {
    if (currentKey === key) {
        stopVoicePreview();
        return;
    }

    stopVoicePreview();
    audioManager.stopAll();

    const audio = new Audio(url);
    currentAudio = audio;
    currentKey = key;
    notify();

    audio.onended = () => {
        if (currentAudio !== audio) return;
        stopVoicePreview();
    };
    audio.onerror = () => {
        if (currentAudio !== audio) return;
        console.error("音频播放失败:", url);
        stopVoicePreview();
    };
    void audio.play().catch((err) => {
        if (currentAudio !== audio) return;
        console.error("播放音频出错:", err);
        stopVoicePreview();
    });
}

export function subscribeVoicePreview(listener: VoicePreviewListener): () => void {
    listeners.add(listener);
    listener(currentKey);
    return () => {
        listeners.delete(listener);
    };
}

export function parseVoicePreviewId(playingKey: string | null, prefix: string): number | null {
    if (!playingKey || !playingKey.startsWith(prefix)) return null;
    const id = Number(playingKey.slice(prefix.length));
    return Number.isFinite(id) ? id : null;
}
